export const fromMaybe = <T>(value: T | undefined | null, defaultValue: T): T => {
  if (value === undefined || value === null) {
    return defaultValue
  }
  return value
}
